/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

import {SCROLLBAR_HEIGHT, scrollbarStyles} from 'constants/scrollbar';

export const Root = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(6),
}));

export const Container = styled(Box)(() => ({
  position: 'relative',
  overflow: 'hidden',
}));

export const Scroller = styled(Box)(({theme}) => ({
  ...scrollbarStyles(theme, 'dark'),
  overflowX: 'auto',
  overflowY: 'hidden',
}));

export const Content = styled(Box)(() => ({
  borderRadius: 8,
  display: 'flex',
  gap: 1,
  paddingBottom: 1,
  overflow: 'hidden',
  width: 'max-content',
  position: 'relative',
  zIndex: 0,
}));

export const FadeBox = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  width: '64px',
  height: `calc(100% - ${SCROLLBAR_HEIGHT}px)`,
  zIndex: 1,
  pointerEvents: 'none',
  background: `linear-gradient(90deg, rgba(45, 46, 50, 0.00) 0%, ${theme.palette.semantic_dark?.surface.surface1} 100%)`,
}));

interface HeaderBoxProps {
  customColor?: string;
}

export const HeaderBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'customColor',
})<HeaderBoxProps>(({theme, customColor}) => ({
  display: 'flex',
  gap: theme.spacing(2),

  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '22px',
  color: customColor,

  '.MuiSvgIcon-root': {
    color: customColor,
    fontSize: '22px',
  },
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const DescriptionBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const BadgeBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const Badge = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  borderRadius: '12px',
  background: theme.palette.semantic_light?.primary.container,
  padding: theme.spacing(1, 2),

  color: theme.palette.semantic_light?.primary.onContainer,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
}));
